import Header from "../../PageElements/Navbar/Navbar";
import Footer from '../../PageElements/Footer/Footer';
import Presentation from "../../PageElements/Presentation/Presentation";
import Values from "../../PageElements/Values/Values";
import MariaPenhaCase from "../../PageElements/ExampleCase/MariaPenhaCase";
import OdsPremisses from '../../PageElements/OdsPremises/OdsPremises';
import AboutUs from '../../PageElements/AboutUs/AboutUs';
import ContactUs from '../../PageElements/ContactUs/ContactUs';
import { useEffect } from "react";

export default function Home() {

    useEffect(() => {
        return window.location.href = 'https://direitoagil.tech'
    }, [])


    return (
        <>
            <section id="header" >
                <Header />
            </section>
            <section id="presentation">
                <Presentation />
            </section>
            <section id="values">
                <Values />
            </section>
            <section id="cases">
                <MariaPenhaCase />
            </section>
            <section id="ods">
                <OdsPremisses />
            </section>
            <section id="aboutUs">
                <AboutUs />
            </section>
            <section id="contact">
                <ContactUs />
            </section>
            <Footer id="footer" />
        </>
    )
}